import React from 'react'

import { routing } from '@utils/routing'

import type { ConnectedSitesViewProps } from './ConnectedSitesView'
import { ConnectedSitesView } from './ConnectedSitesView'
import { useConnectedShopsQuery } from './queries/useConnectedShopsQuery'

export const ConnectedSitesContainer = () => {
  const { connectedShopsQuery } = useConnectedShopsQuery()

  const handleItemManage = (
    item: NonNullable<
      ReturnType<typeof useConnectedShopsQuery>['connectedShopsQuery']['data']
    >['shops'][number],
  ) => {
    window.location.href = `${item.internalBaseUri}${routing.home}`
  }

  const items: ConnectedSitesViewProps['items'] = connectedShopsQuery.data?.shops.map((item) => ({
    title: item.name,
    href: item.baseUri,
    image: item.logoUri,
    background: `${item.baseUri}/platform/theme/background.png`,
    onManage: () => handleItemManage(item),
  }))

  return <ConnectedSitesView items={items} />
}
